/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.25",
    versionName: "0.2.0-nightly.2025.8.25",
    versionChannel: "nightly",
    buildDate: "2025-08-25T00:07:47.999Z",
    commitHash: "18697ae67119737381ab6b1289babc1cf8286ed2",
};
